<template>
  <a-modal
    title="操作"
    :width="500"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" >
        <a-form-item
          label="用户名"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }" >

          <select-user ref="user" style="margin-left:10px" v-if="visible"></select-user>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { searchForUser, addProjectUser } from '@/api/project'
// import { debounce } from '@/utils/util'
import SelectUser from '@/components/selector/SelectUser'
export default {
  name: 'AddUserModal',
  components: {
    SelectUser
  },
  data () {
    this.lastFetchId = 0
    // this.handleChange = debounce(this.handleChange, 300);
    return {
      fetching: false,
      likeUsers: [],
      values: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible: false,
      confirmLoading: false,
      mdl: {}
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
    console.log('form::', this.form)
  },
  created () {

  },
  methods: {
    add () {
      this.visible = true
    },
    close () {
      this.$emit('close')
      this.visible = false
    },
    handleOk () {
      const projectId = this.$store.getters.projectId
      const _this = this
      const data = {}
      this.$refs.user.selectedUsers.map(user => {
        addProjectUser({
          item_id: projectId,
          member_uid: user.uid,
          member_permission: 'user_diagnose',
          user_name: ''
        }).then(res => {
          _this.$message.success('添加用户“' + user.label[1].text + '”成功')
          _this.$emit('add_user_ok')
        }).catch(() => {
          _this.$message.error('添加用户“' + user.label[1].text + '”失败')
        }).finally(() => {
          _this.confirmLoading = false
          _this.close()
        })
      })
      this.$refs.user.values = []
      _this.confirmLoading = true
    },
    handleCancel () {
      this.close()
    },
    fetchUser (value) {
      this.lastFetchId += 1
      const fetchId = this.lastFetchId
      this.likeUsers = []
      this.data = []
      this.fetching = true
      const data = {}
      data.user_name = value
      data.user_mail = ''
      data.item_id = this.$store.getters.projectId
      searchForUser(data).then(
        res => {
          if (fetchId !== this.lastFetchId) { // for fetch callback order
            return
          }
          const _likeUsers = this.likeUsers
          if (res.data.length == 0) _likeUsers.push({ name: "no name like \'" + value + "\'" })
          else {
            res.data.map(user => {
              _likeUsers.push({
                user_name: user.user_name,
                uid: user.uid
              })
            })
          }

          this.fetching = false
        }
      ).catch(() => {
        this.likeUsers = { name: 'searching failed ...' }
        this.fetching = false
      })
    },
    handleChange (values) {
      Object.assign(this, {
        values,
        likeUsers: [],
        fetching: false
      })
    }
  }
}
</script>
